<template>
  <div style="display: inline-block">
    <v-btn color="primary" @click='pickFile'>Upload</v-btn>
    <input
            type="file"
            style="display: none"
            ref="image"
            accept="image/*"
            @change="onFilePicked"
    >
  </div>
</template>

<script>
export default {
  data () {
    return {
      imageName: '',
      imageUrl: '',
      imageFile: ''
    }
  },
  watch: {
    imageFile () {
      if (this.imageFile) {
        this.$emit('file', {
          file: this.imageFile,
          name: this.imageName,
          dataUrl: this.imageUrl
        })
        this.imageFile = null
      }
    }
  },
  methods: {
    pickFile () {
      this.imageName = ''
      this.imageFile = ''
      this.imageUrl = ''
      this.$refs.image.value = ''
      this.$refs.image.click()
    },

    onFilePicked (e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result
          this.imageFile = files[0] // this is an image file that can be sent to server...
        })
      } else {
        this.imageName = ''
        this.imageFile = ''
        this.imageUrl = ''
      }
    }
  }
}
</script>

<style scoped>

</style>
